export default __webpack_public_path__ + "static/og-a2621288d5a96b4589014bc574ea7579.png";